import { lazy, Suspense } from 'react';
import { Trans } from 'react-i18next';

import styles from './api-error-block.module.scss';

const Button = lazy(() => import('core/generic/elements/button'));
const InfoBlock = lazy(() => import('core/generic/elements/info-block'));

export const ApiErrorBlock = ({
	apiErrorMessage,
}: {
	apiErrorMessage: string;
}) => {
	return (
		<Suspense fallback={null}>
			<>
				{apiErrorMessage && (
					<InfoBlock variant="error">
						<div className={styles['error-info-block']}>
							<p className="body-small">
								<Trans
									i18nKey={apiErrorMessage}
									components={{
										a: (
											<Button
												key="0"
												variant="link"
												dimension="medium"
												className={
													styles['inline-button']
												}
											/>
										),
									}}
								/>
							</p>
						</div>
					</InfoBlock>
				)}
			</>
		</Suspense>
	);
};
